module.exports = __webpack_public_path__ + "img/p2-p2-diaoxiang23.6310b196.png";